import { IChuongTrinhDaoTaoSoSanhActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoSoSanhActionTypes";
import { IChuongTrinhDaoTaoSoSanhReducer } from "../../reducer-model/ctdt/IChuongTrinhDaoTaoSoSanhReducer";

const iniState: IChuongTrinhDaoTaoSoSanhReducer = {
    isInitialized: false,
    focusedTab: "xem_2_chuong_trinh",
    chuongTrinhGoc: undefined,
    chuongTrinhSoSanh: undefined,
};

export const chuongTrinhDaoTaoSoSanhReducer = (
    state: IChuongTrinhDaoTaoSoSanhReducer = iniState,
    action: IChuongTrinhDaoTaoSoSanhActionTypes
): IChuongTrinhDaoTaoSoSanhReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_SO_SANH_INI_SUCCESS":
            return {
                ...state,
                isInitialized: true,
            };
        case "CHUONG_TRINH_DAO_TAO_SO_SANH_CHANGE_FOCUSED_TAB_SUCCESS":
            return {
                ...state,
                focusedTab: action.payload,
            };
        case "CHUONG_TRINH_DAO_TAO_SO_SANH_CHANGE_CHUONG_TRINH_GOC_SUCCESS":
            return {
                ...state,
                chuongTrinhGoc: action.payload,
            };
        case "CHUONG_TRINH_DAO_TAO_SO_SANH_CHANGE_CHUONG_TRINH_SO_SANH_SUCCESS":
            return {
                ...state,
                chuongTrinhSoSanh: action.payload,
            };
        default:
            return state;
    }
};
